import { PosModel } from '@/types'

/**
 * Asks the cashier for what an item needs before it reaches the cart (A6/A7): a price for `variable` and zero-priced
 * products, a quantity for products sold by unit (2.5 kg). One dialog, mounted once in the layout, answers.
 */
export interface ItemNeeds {
  price: boolean
  quantity: boolean
}

export interface ItemDetails {
  price?: number
  quantity?: number
}

export interface ItemPromptRequest {
  product: PosModel.Product
  needs: ItemNeeds
  resolve: (details: ItemDetails | null) => void
}

let host: ((request: ItemPromptRequest) => void) | null = null

/** `null` when the cashier cancels (or no dialog is mounted). */
export const askItemDetails = (product: PosModel.Product, needs: ItemNeeds) =>
  new Promise<ItemDetails | null>((resolve) => (host ? host({ product, needs, resolve }) : resolve(null)))

export const registerItemPrompt = (fn: (request: ItemPromptRequest) => void) => {
  host = fn
  return () => {
    if (host === fn) host = null
  }
}

/** Quantities sold by unit keep three decimals (grams of a kilogram). */
export const roundQty = (n: number) => Math.round(n * 1000) / 1000
